// @flow
import Maybe from 'folktale/maybe';
import { isObject, identity, assign, get } from 'lodash/fp';

export const getIdFromProps = (_: Object, props: Object) => (props && props.id) || '';
export const getParentFromProps = (_: Object, props: Object) => (props && props.parent) || '';
export const getCapabilityNameFromProps = (_: Object, props: Object) => (props && props.capabilityName) || '';
export const stateIdentity = (state: Object) => state || {};
export const getProp = (propName: string) => (item: Object) => item && item.props && item.props[propName];
export const getStateAttribute = (attributeName: string) => (item: Object) =>
    Maybe.fromNullable(get(['state', attributeName], item));

type Props = {} | string;
type State = *;
type Selector = (State, ?Props) => any;
type Bindable = Selector => Props => Selector;

export const bindable: Bindable = fn => boundProps => (state, props) => {
    const concat = isObject(boundProps) ? assign : identity;
    const nextProps = concat(boundProps, props);
    return fn(state, nextProps);
};



// WEBPACK FOOTER //
// ./src/core/state/selectors.js